<template>
  <v-dialog v-model="navigation.resumeCRMWhatsappConversationDialogIsVisible" @update:model-value="navigation.resumeCRMWhatsappConversationDialogIsVisible == false ? closeResumeCRMWhatsappConversationDialog() : null" max-width="50vw" style="cursor: default; user-select: none;">
    <v-card max-width="50vw">
      <template v-if="loader.selectCRMWhatsappConversationFromResumeCRMWhatsappConversationDialog">
        <div style="width: 100%; text-align: center; margin: 10px 0px 10px 0px;">
          <v-progress-circular indeterminate color="indigo"></v-progress-circular>
        </div>
      </template>
      <template v-else>
        <template v-if="display.CRMWhatsappConversation.isAvailable">
          <template v-if="display.CRMWhatsappConversation.offsetDayCRMWhatsappConversation <= navigation.offsetDayCRMWhatsappConversation">
            <v-alert color="primary" variant="tonal">
              <template v-slot:prepend>
                <v-icon color="primary">mdi-chat-plus</v-icon>
              </template>
              <template v-slot:title>
                <h3>ATENCIÓN</h3>
              </template>
              <p style="margin-top: 5px;">Se retomará la conversación <strong>{{ display.CRMWhatsappConversation.CRMWhatsappConversationID }}</strong></p>
              <div style="display: flex; align-items: center; gap: 10px; margin-top: 20px;">
                <v-tooltip :disabled="systemInformationData.tooltipDisabled" text="Contacto" location="top">
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props" color="primary" class="hoverableElement">mdi-account</v-icon>
                  </template>
                </v-tooltip>
                <p>{{ $displayFunctions.default.parseCRMWhatsappContactNameToDisplay(display.CRMWhatsappConversation) }}</p>
              </div>
              <div style="display: flex; align-items: center; gap: 10px; margin-top: 5px;">
                <v-tooltip :disabled="systemInformationData.tooltipDisabled" text="Teléfono" location="top">
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props" color="primary" class="hoverableElement">mdi-phone</v-icon>
                  </template>
                </v-tooltip>
                <p>{{ $displayFunctions.default.fromPhoneNumberToCountryCodePhoneNumberCountryFlag(display.CRMWhatsappConversation.CRMWhatsappConversationPhoneNumber, false) }}</p>
              </div>
              <div style="display: flex; align-items: center; gap: 10px; margin-top: 5px;">
                <v-tooltip :disabled="systemInformationData.tooltipDisabled" text="Resultado" location="top">
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props" color="primary" class="hoverableElement">mdi-timeline</v-icon>
                  </template>
                </v-tooltip>
                <p>{{ display.CRMWhatsappConversation.CRMWhatsappConversationResult }}</p>
              </div>
              <div style="display: flex; align-items: center; gap: 10px; margin-top: 5px;">
                <v-tooltip :disabled="systemInformationData.tooltipDisabled" text="Fecha de finalización" location="top">
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props" color="primary" class="hoverableElement">mdi-calendar</v-icon>
                  </template>
                </v-tooltip>
                <p>{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(display.CRMWhatsappConversation.CRMWhatsappConversationEndDatetime) }}</p>
              </div>
              <v-btn @click="resumeCRMWhatsappConversationFromResumeCRMWhatsappConversationDialog()" :disabled="loader.resumeCRMWhatsappConversationFromResumeCRMWhatsappConversationDialog" color="indigo" block class="hoverableVButton" style="margin-top: 30px;">
                <v-icon style="margin-right: 10px;">mdi-chat-plus</v-icon>
                <h3>RETOMAR CONVERSACIÓN</h3>
              </v-btn>
              <v-btn @click="closeResumeCRMWhatsappConversationDialog()" :disabled="loader.resumeCRMWhatsappConversationFromResumeCRMWhatsappConversationDialog" color="primary" block class="hoverableVButton" style="margin-top: 15px;">
                <v-icon style="margin-right: 10px;">mdi-close-circle</v-icon>
                <h3>CERRAR</h3>
              </v-btn>
            </v-alert>
          </template>
          <template v-else>
            <v-alert type="info" variant="tonal">
              <template v-slot:title>
                <h3>ATENCIÓN</h3>
              </template>
              <div style="display: flex; align-items: center; gap: 10px; margin-top: 5px;">
                <p>La conversación <strong>{{ display.CRMWhatsappConversation.CRMWhatsappConversationID }}</strong> con el contacto <strong>{{ $displayFunctions.default.parseCRMWhatsappContactNameToDisplay(display.CRMWhatsappConversation) }}</strong> tiene más de <strong>{{ navigation.offsetDayCRMWhatsappConversation }} días</strong> desde su finalización, solicite a su administrador de sistema que retome la conversación por este medio</p>
              </div>
              <v-btn @click="closeResumeCRMWhatsappConversationDialog()" color="primary" block class="hoverableVButton" style="margin-top: 20px;">
                <v-icon style="margin-right: 10px;">mdi-close-circle</v-icon>
                <h3>CERRAR</h3>
              </v-btn>
            </v-alert>
          </template>
        </template>
        <template v-else>
          <v-alert type="info" variant="tonal">
            <template v-slot:title>
              <h3>ATENCIÓN</h3>
            </template>
            <div style="display: flex; align-items: center; gap: 10px; margin-top: 5px;">
              <p>La conversación <strong>{{ display.CRMWhatsappConversation.CRMWhatsappConversationID }}</strong> con el contacto <strong>{{ $displayFunctions.default.parseCRMWhatsappContactNameToDisplay(display.CRMWhatsappConversation) }}</strong> está activa en este momento con el agente
                <span>
                  <v-chip v-if="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == display.CRMWhatsappConversation.CRMWhatsappConversationCurrentCRMAgentID)" :color="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == display.CRMWhatsappConversation.CRMWhatsappConversationCurrentCRMAgentID).CRMAgentColor || 'primary'" variant="flat" label>
                    <div style="display: flex; align-items: center;">
                      <img :src="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == display.CRMWhatsappConversation.CRMWhatsappConversationCurrentCRMAgentID).CRMAgentProfilePictureURL || require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                      <p>{{ systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == display.CRMWhatsappConversation.CRMWhatsappConversationCurrentCRMAgentID).CRMAgentName || 'No registrado' }}</p>
                    </div>
                  </v-chip>
                </span>
                . Es necesario transferirla o cerrarla antes de retomar la conversación por este medio
              </p>
            </div>
            <v-btn @click="closeResumeCRMWhatsappConversationDialog()" color="primary" block class="hoverableVButton" style="margin-top: 20px;">
              <v-icon style="margin-right: 10px;">mdi-close-circle</v-icon>
              <h3>CERRAR</h3>
            </v-btn>
          </v-alert>
        </template>
      </template>
    </v-card>
  </v-dialog>
</template>
  
<style scoped>
</style>

<script>
  import { systemInformation } from '@/utilities/systemInformation';
  export default {
    inject: ['$generalFunctions', '$displayFunctions'],
    data: () => 
    ({
      navigation: 
      {
        resumeCRMWhatsappConversationDialogIsVisible: false,
        CRMWhatsappConversationID: null,
        offsetDayCRMWhatsappConversation: null
      },
      display: 
      {
        CRMWhatsappConversation: null
      },
      loader: 
      {
        selectCRMWhatsappConversationFromResumeCRMWhatsappConversationDialog: false,
        resumeCRMWhatsappConversationFromResumeCRMWhatsappConversationDialog: false
      },
      systemInformationData: 
      {
        CRMAccountID: null,
        CRMAgent: null,
        CRMAgents: [],
        tooltipDisabled: false,
        updateSubscription: null
      }
    }),

    methods:
    {

      async resumeCRMWhatsappConversationFromResumeCRMWhatsappConversationDialog(){
        this.loader.resumeCRMWhatsappConversationFromResumeCRMWhatsappConversationDialog = true;
        const resumeCRMWhatsappConversationFromResumeCRMWhatsappConversationDialogRequestQuery =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
            'CRMAgentID': this.systemInformationData.CRMAgent.CRMAgentID
          },
          'CRMWhatsappConversationID': this.navigation.CRMWhatsappConversationID
        };
        const resumeCRMWhatsappConversationFromResumeCRMWhatsappConversationDialogResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappConversation/functions/resumeCRMWhatsappConversationFromResumeCRMWhatsappConversationDialog', resumeCRMWhatsappConversationFromResumeCRMWhatsappConversationDialogRequestQuery);
        if (resumeCRMWhatsappConversationFromResumeCRMWhatsappConversationDialogResult.success){
          this.$root.notificationDialog.showSystemNotificationDialog('resumeCRMWhatsappConversationFromResumeCRMWhatsappConversationDialog_success', 'success', `La conversación con ${this.$displayFunctions.default.parseCRMWhatsappContactNameToDisplay(this.display.CRMWhatsappConversation)} ha sido retomada`, null, true);
          this.closeResumeCRMWhatsappConversationDialog();
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('resumeCRMWhatsappConversationFromResumeCRMWhatsappConversationDialog_error', 'error', `Ha ocurrido un error inesperado al retomar la conversación con ${this.$displayFunctions.default.parseCRMWhatsappContactNameToDisplay(this.display.CRMWhatsappConversation)}, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema`, null, true);
        }
        this.loader.resumeCRMWhatsappConversationFromResumeCRMWhatsappConversationDialog = false;
      },

      async selectCRMWhatsappConversationFromResumeCRMWhatsappConversationDialog(){
        this.loader.selectCRMWhatsappConversationFromResumeCRMWhatsappConversationDialog = true;
        const selectCRMWhatsappConversationFromResumeCRMWhatsappConversationDialogRequestQuery =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID
          },
          'CRMWhatsappConversationID': this.navigation.CRMWhatsappConversationID
        };
        const selectCRMWhatsappConversationFromResumeCRMWhatsappConversationDialogResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappConversation/functions/selectCRMWhatsappConversationFromResumeCRMWhatsappConversationDialog', selectCRMWhatsappConversationFromResumeCRMWhatsappConversationDialogRequestQuery);
        if (selectCRMWhatsappConversationFromResumeCRMWhatsappConversationDialogResult.success){
          this.display.CRMWhatsappConversation = selectCRMWhatsappConversationFromResumeCRMWhatsappConversationDialogResult.result;
          this.loader.selectCRMWhatsappConversationFromResumeCRMWhatsappConversationDialog = false;
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('selectCRMWhatsappConversationFromResumeCRMWhatsappConversationDialog_error', 'error', `Ha ocurrido un error inesperado al obtener la conversación ${this.navigation.CRMWhatsappConversationID}, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema`, null, true);
          this.closeResumeCRMWhatsappConversationDialog();
        }
      },
      
      async getSystemInformationData(){
        try {
          systemInformation.setGeneralFunctions(this.$generalFunctions.default);
          const systemInformationResult = await systemInformation.startup();
          if (systemInformationResult.success){
            this.systemInformationData.CRMAccountID = systemInformation.getCRMAccountID;
            this.systemInformationData.CRMAgent = systemInformation.getCRMAgent;
            this.systemInformationData.CRMAgents = systemInformation.getCRMAgents;
            this.systemInformationData.tooltipDisabled = systemInformation.getTooltipDisabled;
            if (!this.systemInformationData.updateSubscription){
              this.systemInformationData.updateSubscription = systemInformation.subscribeToUpdate((updatedSystemInformationData) => {
                this.systemInformationData.tooltipDisabled = updatedSystemInformationData.tooltipDisabled;
              });
            } 

            if (this.systemInformationData.CRMAgent.CRMAgentPermissions.find(CRMAgentPermission => CRMAgentPermission.CRMAgentPermissionName == '/CRMWhatsappConversations/offsetDayCRMWhatsappConversation')){
              this.navigation.offsetDayCRMWhatsappConversation = parseInt(this.systemInformationData.CRMAgent.CRMAgentPermissions.find(CRMAgentPermission => CRMAgentPermission.CRMAgentPermissionName == '/CRMWhatsappConversations/offsetDayCRMWhatsappConversation').CRMAgentPermissionValue);
            }
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('closeCRMWhatsappConversationDialog_getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
            this.closeResumeCRMWhatsappConversationDialog();
          }
        } catch {
          this.$root.notificationDialog.showSystemNotificationDialog('closeCRMWhatsappConversationDialog_getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
          this.closeResumeCRMWhatsappConversationDialog();
        }
      },

      async openResumeCRMWhatsappConversationDialog(CRMWhatsappConversationID){
        await this.getSystemInformationData();
        this.loader.selectCRMWhatsappConversationFromResumeCRMWhatsappConversationDialog = false;
        this.navigation.CRMWhatsappConversationID = CRMWhatsappConversationID;
        this.navigation.resumeCRMWhatsappConversationDialogIsVisible = true;
        await this.selectCRMWhatsappConversationFromResumeCRMWhatsappConversationDialog();
      },

      closeResumeCRMWhatsappConversationDialog(){
        this.navigation.resumeCRMWhatsappConversationDialogIsVisible = false;
        this.$emit('closeResumeCRMWhatsappConversationDialog');
      }
    }
  }
</script>